// TODO: get title with i18n
// export const RESET_PASSWORD_RESPONSE = 'RESET_PASSWORD_RESPONSE';
// export const RESET_PASSWORD_RESPONSE_TITLE = 'RESET_PASSWORD_RESPONSE_TITLE';

export const RESET_PASSWORD_RESPONSE = 'An email has been sent to your address, please follow the instructions to reset your password';
export const RESET_PASSWORD_RESPONSE_TITLE = 'Please check your email !';
